import { AxiosResponse } from "axios";
import ApiConstants from "../../../../../constants/api_constants";
import { request } from "../../../../../network/axiosInstance";

export class AuthenticationApiService {
    private readonly authBaseUrl: string;

    constructor() {
        this.authBaseUrl = ApiConstants().authentication;
    }

    async sendVerificationEmail(email: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}resend-verification/${email}`,
            requiresToken: true,
        });
        return response
    }
} 